import {Component, OnInit} from '@angular/core';
import {InternesParams} from '@domain/participant/internes-params';
import {UtilisateursParametresService} from '@services/admin/entreprise/utilisateurs/utilisateurs-parametres.service';

/**
 * Composant de gestion des paramètres des internes
 */
@Component({
    selector: 'internes-params',
    templateUrl: './internes-params.component.html'
})
export class InternesParamsComponent implements OnInit {
    /** Modèle des paramètres */
    internesParams: InternesParams = new InternesParams();

    /**
     * Constructeur
     *
     * @param utilisateursParametresService
     */
    constructor(
        private utilisateursParametresService: UtilisateursParametresService
    ) {}

    /**
     * Initialisation
     */
    ngOnInit() {
        //Chargement des paramètres
        this.utilisateursParametresService.loadInternesParams().subscribe(result => {
            if (result?.data) {
                this.internesParams.autoriserAdressePerso = result.data.autoriserAdressePerso ?? true;
                this.internesParams.autoriserAdressePro = result.data.autoriserAdressePro ?? true;
            }
        });
    }
}